import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "container-fluid px-0"
}
const _hoisted_3 = {
  key: 0,
  class: "the-app-body"
}
const _hoisted_4 = {
  key: 1,
  class: "the-app-body"
}
const _hoisted_5 = {
  key: 1,
  class: "initial-loading-spinner"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  id: "toasts",
  class: "toasts"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_header = _resolveComponent("app-header")!
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_network_error = _resolveComponent("network-error")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_LoaderSpinner = _resolveComponent("LoaderSpinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.state.isJwtTokenExpired)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_app_header, {
            "account-uri": _ctx.state.accountUri,
            onLogoutClicked: _ctx.logout
          }, null, 8, ["account-uri", "onLogoutClicked"]),
          (_ctx.hasNetworkError)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_sidebar, {
                  "business-name": _ctx.state.businessName,
                  "sidebar-list": _ctx.sidebarList,
                  "hide-dashboard": ""
                }, null, 8, ["business-name", "sidebar-list"]),
                _createVNode(_component_network_error)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_sidebar, {
                  "business-name": _ctx.state.businessName,
                  "sidebar-list": _ctx.sidebarList,
                  "hide-dashboard": ""
                }, null, 8, ["business-name", "sidebar-list"]),
                _createVNode(_component_router_view)
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createVNode(_component_LoaderSpinner)
        ])),
    _hoisted_6
  ]))
}